import { Dispatch, SetStateAction, useCallback } from 'react';
import { DataRoom } from 'router/subrouters/DataRoom/models/DataRoom';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import useSocketEvent from 'services/socketService/hooks/useSocketEvent';
import { DataRoomIndexUpdatedEventData } from 'services/socketService/socketEventData';
import { LISTEN_EVENTS } from 'services/socketService/socketEventNames';

const useUpdateIndex = (
  dataRoomId: string,
  setDataRoom: Dispatch<SetStateAction<DataRoom>>,
  setCurrentlyDisplayedNodes: Dispatch<SetStateAction<DataRoomNode[]>>,
) => {
  const updateIndex = useCallback(
    ({
      dataRoomNodes,
      dataRoom: { _id, docIndexUpdatedAt },
    }: DataRoomIndexUpdatedEventData) => {
      if (dataRoomId !== _id) return;

      setDataRoom((prev) => ({
        ...prev,
        docIndexUpdatedAt,
      }));

      setCurrentlyDisplayedNodes((prev) =>
        prev.map((el) => {
          const found = dataRoomNodes.find(({ _id }) => _id === el._id);

          if (!found) return el;

          return { ...el, ...found };
        }),
      );
    },
    [dataRoomId, setCurrentlyDisplayedNodes, setDataRoom],
  );

  useSocketEvent(LISTEN_EVENTS.DATA_ROOM_INDEX_UPDATED, updateIndex);
};

export default useUpdateIndex;
